// React
import React, { useContext, useEffect, useState } from "react";

// Translations, utility functions and hooks
import { useTranslation } from "react-i18next";

// API endpoints
import { updatePage } from "../../../../../../../api/endpoints/cp";

// State management
import { DispatchErrorContext } from "../../../../../../../context/ErrorContext";
import { PageContext } from "../../../../../../context/PageContext";

// Components
import { ToggleSwitch } from "../../../../../Buttons/Buttons";

const PositionPublish = ({ loadingPage, white }) => {
  const { t } = useTranslation();
  const { state, dispatch } = useContext(PageContext);
  const errorDispatch = useContext(DispatchErrorContext);
  const [isToggling, setIsToggling] = useState(false);

  // Function to update the page status optimistically
  const optimisticToggle = (publish) => {
    // Return early if the page is already loading or if we are currently toggling
    // This prevents multiple toggles from being initiated at the same time, and ensures that the UI is not updated multiple times, while the API call is in progress
    if (loadingPage?.loadingPage || isToggling) {
      return;
    }

    setIsToggling(true);

    const newStatus = publish ? "publish" : "draft";

    // Optimistic UI update: update the UI immediately
    dispatch({
      type: "page_loaded",
      payload: { ...state.page, status: newStatus },
    });

    onSaveHandler(publish, newStatus); // Proceed with the API call
  };

  // Function to update the page status
  const onSaveHandler = async (publish, newStatus) => {
    try {
      const request = {
        selector: state.page.id,
        body: { status: newStatus },
      };

      const response = await updatePage(request);

      if (!response.success) throw new Error(response.data.data);

      setIsToggling(false); // Done toggling
    } catch (err) {
      // Handle error and display error message
      errorDispatch({
        type: "set_error",
        payload: err.message,
      });

      // Revert the UI update since the server request failed
      dispatch({
        type: "page_loaded",
        payload: state.page,
      });

      setIsToggling(false); // Done toggling, whether successful or not
    }
  };

  return (
    <>
      <ToggleSwitch
        active={state.page.status === "publish"}
        white={white}
        text={
          state.page.status === "publish"
            ? t("common.is_published", "Published")
            : t("common.is_unpublished", "Unpublished")
        }
        isToggling={loadingPage?.loadingPage || isToggling}
        onClick={() => {
          optimisticToggle(state.page.status !== "publish");
        }}
      />
    </>
  );
};

export default PositionPublish;
